// NOTE: Copied from workbench-icons based on guidance from design-systems
// because there was a problem with server side rendering and using these icons.
const Home = () => (
  <svg viewBox="0 0 16 16" width="1em" fill="currentColor">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5 13.5V6.687a.5.5 0 00-.203-.402l-5-3.7a.5.5 0 00-.594 0l-5 3.7a.5.5 0 00-.203.402V13.5h2.923v-3.429c0-.966.784-1.75 1.75-1.75h1.654c.966 0 1.75.784 1.75 1.75V13.5H13.5zM1.81 5.079A2 2 0 001 6.687V14a1 1 0 001 1h3.923a1 1 0 001-1v-3.929a.25.25 0 01.25-.25h1.654a.25.25 0 01.25.25V14a1 1 0 001 1H14a1 1 0 001-1V6.687a2 2 0 00-.81-1.608l-5-3.699a2 2 0 00-2.38 0l-5 3.699z"
    />
  </svg>
);

export default Home;
